// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1UO6H","label":"Category_label__1hHT6","content":"Category_content__3ziQz","header":"Category_header__MP5Fc","location":"Category_location__17Ld7"};